var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"succes-dialog"},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/check-circle-fill.svg")}}),_c('p',[_vm._v(_vm._s(_vm.msg))])])
}
var staticRenderFns = []

export { render, staticRenderFns }